import {SidebarLanguages as LanguagesComponent} from '@github-ui/code-view-sidebar/components/SidebarLanguages'
import type {SidebarLanguagesResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarLanguages({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'languages', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/languages`)
      return (await r.json()) as SidebarLanguagesResponse
    },
  })

  if (!data) return null
  return <LanguagesComponent {...data} />
}
